import { ErrorMessage, Form, Formik, FormikHelpers } from 'formik';
import { DocumentTitle } from 'library/head';
import ActionButton from 'modules/auth/components/ui/ActionButton';
import OtpInput from 'react18-input-otp';
import * as Yup from 'yup';
import GridwallCardShadow from '../GridwallCardShadow/GridwallCardShadow';

export interface IVerifyOtpForm {
    accessCode: string;
}

const VerifyOtpSchema = Yup.object({
    accessCode: Yup.string().trim().required('Access Code is required.'),
});

interface IVerifyGridwallAccessCodeOptions {
    onSubmit: (accessCode: string) => void;
    isLoading: boolean;
    token: string;
}

const VerifyGridwallAccessCodePage = (props: IVerifyGridwallAccessCodeOptions) => {
    const { token, isLoading, onSubmit } = props;

    const handleSubmit = (values: IVerifyOtpForm, formikHelpers: FormikHelpers<IVerifyOtpForm>) => {
        localStorage.setItem(`accessCode_${token}`, values.accessCode);

        onSubmit(values.accessCode);

        // formikHelpers.resetForm();azszfhi
    };

    return (
        <>
            <DocumentTitle>Verify GridWall Access</DocumentTitle>

            <div className="relative flex h-screen bg-black">
                <div
                    className="grid gap-1 p-1 h-full w-full"
                    style={{
                        gridTemplateColumns: `repeat(3, minmax(0, 1fr))`,
                        gridTemplateRows: `repeat(3, minmax(0, 1fr))`,
                    }}
                >
                    {[...Array(9)].map((_, index) => {
                        return <GridwallCardShadow key={index} cameraIndex={index} />;
                    })}
                </div>

                <div className="absolute inset-0 bg-black/30 backdrop-blur-sm"></div>

                <div className="absolute inset-0 flex items-center justify-center">
                    <div className="bg-white p-8 sm:p-[72px] rounded-lg">
                        <h2>GridWall</h2>
                        <div className="text-grayscale-500 max-w-sm mt-3">Verify Access Code</div>

                        <div className="mt-8">
                            {
                                <Formik
                                    initialValues={{ accessCode: '' }}
                                    enableReinitialize
                                    validationSchema={VerifyOtpSchema}
                                    onSubmit={handleSubmit}
                                >
                                    {({ values, setFieldValue, errors, touched }) => (
                                        <Form>
                                            <OtpInput
                                                inputProps={{
                                                    style: undefined,
                                                }}
                                                containerStyle="flex items-center gap-3 sm:gap-5"
                                                inputStyle="text-grayscale-900 text-xl font-semibold text-center w-full sm:w-14 h-12 sm:h-14 border border-grayscale-300 rounded-lg focus:border-primary focus:outline focus:outline-2 focus:outline-primary/10"
                                                errorStyle="border-[#D55650] outline outline-[#D55650]/10 focus:border-[#D55650] focus:outline-[#D55650]/10"
                                                value={values.accessCode}
                                                onChange={(val: string) => setFieldValue('accessCode', val)}
                                                numInputs={4}
                                                hasErrored={Boolean(touched.accessCode && errors.accessCode)}
                                            />

                                            <ErrorMessage
                                                component="div"
                                                className="form-error-message text-sm"
                                                name="accessCode"
                                            />

                                            <div className="flex flex-col gap-6 mt-8">
                                                <ActionButton
                                                    isLoading={isLoading}
                                                    loadingText="Verifying Access Code"
                                                    disabled={values.accessCode.length < 4}
                                                >
                                                    Verify Access Code
                                                </ActionButton>
                                            </div>
                                        </Form>
                                    )}
                                </Formik>
                            }
                        </div>

                        <div className="mt-14">
                            <div className="text-grayscale-500 flex items-center justify-between">
                                <span>Powered By</span>
                                <img className="h-8 object-contain" src="/logos/logo.png" alt="ProgressCenter logo" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default VerifyGridwallAccessCodePage;
